<script setup lang="ts">
import UiModal from '@boats/ui/components/UiModal.vue'

const modals = useModalsStore()
</script>

<template>
  <UiModal
    v-model="modals.isShareModalOpen"
    class="app-modal-share"
    @close="modals.closeShareModal"
  >
    <h2 class="h4 mb-10">
      {{ $t('string.Share-this-page') }}
    </h2>

    <AppSharer />
  </UiModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-share {
  .ui-modal__content {
    text-align: center;
  }
}
</style>
